<template>
    <div v-if="getCompanys">
        <invite-search-header :page-name="headerText"></invite-search-header>
        <invite-search-input ref="input"></invite-search-input>
        <invite-search-list v-show="show"></invite-search-list>
        <invite-search-add ref="add"></invite-search-add>
    </div>
</template>

<script>
    import InviteSearchHeader from 'pages/commons/header/Header'
    import InviteSearchInput from './components/Input'
    import InviteSearchList from './components/List'
    import InviteSearchAdd from './components/Add'
    import {mapGetters, mapMutations} from 'vuex'

    export default {
        data () {
            return {
                show: true
            }
        },
        created () {
            this.loadCompanys()
        },
        activated () {
            this.loadCompanys()
        },
        components: {
            InviteSearchHeader,
            InviteSearchInput,
            InviteSearchList,
            InviteSearchAdd
        },
        watch: {
            getCompanysLoadStatus () {
                if (this.getCompanysLoadStatus == 1) {
                    this.$store.dispatch('startProgress')
                }
                if (this.getCompanysLoadStatus == 2) {
                    this.$store.dispatch('doneProgress')
                }
                if (this.getCompanysLoadStatus == 3) {
                    this.$store.dispatch('doneProgress')
                }
            }
        },
        computed: {
            headerText () {
                return this.$route.params.id == '0' ? '法人招待' : '法人一覧' 
            },
            ...mapGetters(['getCompanys'
                        ,'getCompanysLoadStatus'
                        ,'getRefreshArr'
            ])
        },
        methods: {
            loadCompanys () {
                this.$store.dispatch('loadCompanys')
            },
            addCompany () {
                this.$refs.add.openThis()
            },
            toInviteCode (id, group, name) {
                this.setCurrentCompany({id, group:group, name:name})

                this.$router.push({name: 'InviteCode', params: {
                    type: '1', // m-c
                    group: group
                } })
            },
            toInviteDetail (id, group, name) {
                this.setCurrentCompany({id:id, group:group, name:name})

                this.$router.push({name: 'CompanyDetail', params: {
                    group: group
                }})
            },
            showCompanyList () {
                this.show = true
            },
            hideCompanyList () {
                this.show = false
            },
            ...mapMutations(['setCurrentCompany'])
        }
    }
</script>

<style></style>
